import type { ComponentPropsWithoutRef } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { ArrowBack, new__cn as cn } from '@/package';
import { useSideBarStore } from '@/store';

type GoBackProps = {
  to?: string;
};

const hasHistory = () => window.history.state?.idx > 0;

const GoBack = ({
  to,
  ...props
}: GoBackProps & ComponentPropsWithoutRef<'button'>) => {
  const navigate = useNavigate();

  const handleClickFallback = () => {
    if (to) {
      navigate(to);
    } else {
      navigate('/', { replace: true });
    }
  };

  const { menuList } = useSideBarStore();
  const { top, bottom } = menuList;
  const location = useLocation();
  const isAvailable = [...top, ...(bottom || [])].every(
    menu => menu.path !== location.pathname,
  );

  return (
    <button
      className={cn('cursor-pointer', { hidden: !isAvailable })}
      disabled={!isAvailable}
      onClick={() => {
        if (hasHistory()) {
          navigate(-1);
        } else {
          handleClickFallback();
        }
      }}
      {...props}
    >
      <ArrowBack className="size-6 text-primary-500" />
    </button>
  );
};

GoBack.displayName = 'GoBack';

export default GoBack;
